// extracted by extract-css-chunks-webpack-plugin
module.exports = {"controlsRow":"controlsRow_a3IOE","chartContainer":"chartContainer_fghTs","spinner":"spinner_b+DYJ"};